export interface NoiseData {
  id: string
  db: number
  geo_center: {
    lat: number
    lon: number
  }
}

export interface NoiseStatistics {
  min: number
  max: number
  avg: number
  percentile_25: number
  percentile_50: number
  percentile_75: number
  percentile_95: number
  count: number
}

export interface NoiseStatisticsResponse {
  railway_day: NoiseStatistics | null
  railway_night: NoiseStatistics | null
  road_day: NoiseStatistics | null
  road_night: NoiseStatistics | null
}

export type NoiseIndexType =
  | 'railway-day'
  | 'railway-night'
  | 'road-day'
  | 'road-night'

export interface NoiseSearchFilter {
  bbox?: [number, number, number, number] // [minLon, minLat, maxLon, maxLat]
  polygon?: Array<{ lat: number; lon: number }>
  land_id?: string
  building_id?: string
}

export interface NoiseTileRequest {
  type: NoiseIndexType
  zoom: number
  x: number
  y: number
  filters?: NoiseSearchFilter
}

// Single source of truth for the H3-hex aggregation name used in noise MVT
// tiles. The API uses NOISE_HEX_AGG_NAME as the Elasticsearch agg name; every
// MVT-tile feature ends up with a NOISE_HEX_AGG_PROPERTY property that
// frontends read with `['get', NOISE_HEX_AGG_PROPERTY]`. Renaming either side
// independently makes the noise layer render grey ("No data" tooltips).
export const NOISE_HEX_AGG_NAME = 'avg_db'
export const NOISE_HEX_AGG_PROPERTY = `${NOISE_HEX_AGG_NAME}.value`
